// in src/Dashboard.js
import * as React from "react";
import { Card, CardContent, CardHeader } from '@material-ui/core';

export default () => (
    <Card>
        <CardHeader title="Welcome to the Mace Admin Portal" />
        <CardContent>Lorem ipsum sic dolor amet...</CardContent>
    </Card>
);